import axios from "axios";

// Helper function to get internal API key from URL if present
function getInternalApiKey() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("internal_api_key");
}

// Helper function to create headers with internal API key if present
function getHeaders() {
  const headers = {
    "X-CSRF-Token": document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content"),
  };

  const internalApiKey = getInternalApiKey();
  if (internalApiKey) {
    headers["X-Formester-Internal-Api-Key"] = internalApiKey;
  }

  return headers;
}

function get(url, data = {}) {
  return instance().get(url, { params: data });
}

// requires csrf token
function post(url, data = {}, params = {}) {
  return instance().post(url, data, {
    params,
  });
}

function destroy(url, data = {}) {
  return instance().delete(url, { params: data });
}

// required csrf token
function put(url, data = {}) {
  return instance().put(url, data);
}

function patch(url, data = {}) {
  return instance().patch(url, data);
}

// Private Methods
function instance() {
  return axios.create({
    headers: getHeaders(),
    "Content-Type": "application/json",
    responseType: "json",
  });
}

export { post, get, destroy, put, patch };
